import { render, staticRenderFns } from "./profile-tags.vue?vue&type=template&id=4d0c5265"
import script from "./profile-tags.vue?vue&type=script&lang=js"
export * from "./profile-tags.vue?vue&type=script&lang=js"
import style0 from "./profile-tags.vue?vue&type=style&index=0&id=4d0c5265&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports